module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flexContainer full"
  }, [_c('section', {
    attrs: {
      "id": "sectionPrincipal"
    }
  }, [_c('section', {
    staticClass: "planosWrapper"
  }, [_c('section', {
    staticClass: "searchResultsWrapper"
  }, [(_vm.loading) ? _c('Loader', {
    attrs: {
      "loading": _vm.loading
    }
  }) : _vm._e(), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row d-flex align-items-end mb-5"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col zone-header"
  }, [_c('h1', {
    staticClass: "zone-header-title"
  }, [_vm._v(_vm._s(_vm.$t("help.title")))])])]), _vm._v(" "), _c('div', {
    staticClass: "row "
  }, [_c('div', {
    staticClass: "col d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "rem3rch-input-text",
    attrs: {
      "type": "text",
      "id": "searchBySearch"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "row d-flex align-items-center mt-5"
  }, [_c('div', {
    staticClass: "col-12 col-sm-2 admin-user-manage"
  }, [_c('span', {}, [_vm._v(_vm._s(_vm.$t("help.filter")) + " :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-10"
  }, _vm._l((_vm.apps), function(app, key) {
    return _c('ClientColorButton', {
      key: key,
      staticClass: "mr-4",
      attrs: {
        "size": "l",
        "background-color": _vm.selectedApp && _vm.selectedApp.id === app.id ? 'black' : 'grey'
      },
      on: {
        "click": function($event) {
          _vm.changeApp(app)
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(app.title) + "\n                                    ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row d-flex align-items-center mt-5"
  }, [_c('div', {
    staticClass: "col-12 col-sm-2 admin-user-manage"
  }, [_c('span', {}, [_vm._v(_vm._s(_vm.$t("help.category")) + " :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-10"
  }, [_c('ClientColorButton', {
    staticClass: "mr-4",
    attrs: {
      "size": "l",
      "background-color": _vm.selectedType === 'pdf' ? 'black' : 'grey'
    },
    on: {
      "click": function($event) {
        _vm.changeType('pdf')
      }
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.$t("help.howTo")) + "\n                                    ")]), _vm._v(" "), _c('ClientColorButton', {
    staticClass: "mr-4",
    attrs: {
      "size": "l",
      "background-color": _vm.selectedType === 'video' ? 'black' : 'grey'
    },
    on: {
      "click": function($event) {
        _vm.changeType('video')
      }
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.$t("help.videoTraining")) + "\n                                    ")])], 1)])]), _vm._v(" "), (_vm.isSuperAdmin()) ? _c('div', {
    staticClass: "col-auto"
  }, [_c('div', {
    staticClass: "zone-header d-flex flex-column"
  }, [_c('button', {
    staticClass: "btn btn-add-zone mb-4",
    on: {
      "click": function($event) {
        _vm.showModalUploadPdf = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-xs"
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.$t("help.newPdf")))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-manage-group",
    on: {
      "click": function($event) {
        _vm.showModalUploadVideo = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-xs"
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.$t("help.newVideo")))])])])]) : _vm._e()]), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "table-responsive mt-4"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [(_vm.filesFiltered.length <= 0) ? _c('tr', {
    staticClass: "notfound"
  }, [_c('td', {
    attrs: {
      "colspan": 11
    }
  }, [_vm._v(_vm._s(_vm.$t("help.noItem")))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filesFiltered), function(file, key) {
    return _c('tr', {
      key: key
    }, [(file.type === 'pdf') ? _c('td', {
      staticClass: "icone"
    }, [
      [(file.type === 'pdf') ? _c('a', {
        attrs: {
          "target": "_blank",
          "href": _vm.linkFile(file.application.name, file.filename)
        }
      }, [_c('IconePdf')], 1) : _vm._e()]
    ], 2) : (file.type === 'video') ? _c('td', {
      staticClass: "icone"
    }, [_c('a', {
      attrs: {
        "target": "_blank",
        "href": file.link
      }
    }, [
      [_c('IconeVideo')]
    ], 2)]) : _vm._e(), _vm._v(" "), _c('td', [(file.type === 'pdf') ? _c('a', {
      attrs: {
        "target": "_blank",
        "href": _vm.linkFile(file.application.name, file.filename)
      }
    }, [_vm._v(_vm._s(file.name))]) : (file.type === 'video') ? _c('a', {
      attrs: {
        "target": "_blank",
        "href": file.link
      }
    }, [_vm._v(_vm._s(file.name))]) : _vm._e()]), _vm._v(" "), (_vm.isSuperAdmin()) ? _c('td', {
      staticClass: "edit text-center"
    }, [_c('img', {
      staticClass: "position-relative",
      attrs: {
        "src": require("../../assets/edit.svg"),
        "alt": "edit"
      },
      on: {
        "click": function($event) {
          _vm.showModalModify(file)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.isSuperAdmin()) ? _c('td', {
      staticClass: "delete shrink text-center"
    }, [_c('img', {
      staticClass: "position-relative",
      attrs: {
        "src": require("../../assets/delete.svg"),
        "alt": "edit"
      },
      on: {
        "click": function($event) {
          _vm.deleteHelpFile(file)
        }
      }
    })]) : _vm._e()])
  })], 2)])]) : _vm._e()])], 1)])]), _vm._v(" "), (_vm.showModalUploadPdf) ? _c('ModalHelpUpload', {
    attrs: {
      "selected-application-id": _vm.selectedApp.id,
      "applications": _vm.apps,
      "type-upload": 'pdf',
      "selected-file": _vm.selectedHelpingFile
    },
    on: {
      "uploadSuccess": _vm.uploadSuccess,
      "closed": function($event) {
        _vm.showModalUploadPdf = false;
        _vm.selectedHelpingFileId = null;
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showModalUploadVideo) ? _c('ModalHelpUpload', {
    attrs: {
      "selected-application-id": _vm.selectedApp.id,
      "applications": _vm.apps,
      "type-upload": 'video',
      "selected-file": _vm.selectedHelpingFile
    },
    on: {
      "uploadSuccess": _vm.uploadSuccess,
      "closed": function($event) {
        _vm.showModalUploadVideo = false;
        _vm.selectedHelpingFileId = null;
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "m-0 pointer ml-3",
    attrs: {
      "for": "searchBySearch"
    }
  }, [_c('i', {
    staticClass: "fa fa-search fa-lg color-grey"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02f74096","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/help/Help.vue
// module id = 2981
// module chunks = 0